function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
/* global angular */
(function () {
  'use strict';

  angular.module('wsLrs.controllers').config(['$routeProvider', function ($routeProvider) {
    $routeProvider.when('/data/learners', {
      templateUrl: 'modules/app/data/learners/learners.html',
      controller: 'LearnersCtrl',
      resolve: {
        include: function include() {
          return 'index';
        }
      }
    });
  }]).controller('LearnersCtrl', ['include', '$scope', '$q', '$location', 'Logger', 'UserRoles', 'User', '$timeout', '$http', 'Api', 'Utils', function (include, $scope, $q, $location, Logger, UserRoles, User, $timeout, $http, Api, Utils) {
    var userNotAdmin = !UserRoles.isOrgAdmin(User.get());
    if (userNotAdmin) {
      $location.path('/');
    }

    // TODO: Include logic determining if they can set users to active
    //  i.e If they have 200 licensed, and 199 active, don't let them
    //  set 2 users to "Active" because then they will be over license.

    $scope.include = include;
    $scope.section = 'learners';
    $scope.searchQuery = '';
    $scope.isLoading = {
      query: true,
      page: true
    };
    $scope.selectedType = "People";
    $scope.checkedRows = []; // List of IDs that will be passed to a multi-put
    $scope.statuses = ['Active', 'Inactive'];
    $scope.allowedStatuses = ['Inactive']; // This list populates the "Mark As:" combo-box. It's updated to prevent setting active users to active, tc
    $scope.statusFilter = 'ACTIVE'; // Initial filter will display all inactive
    $scope.showOverviewPanel = true;
    $scope.licensedDescription = 'The number of active learners allowed for this organization.';
    $scope.usageDescription = 'The percentage of learners currently being reported on, calculated on active learners divided by licensed learners.';
    $scope.activeDescription = 'The number of Active Learners in your account. Active Learners will be included in reports, and they can be found in Your Organization.';
    $scope.inactiveDescription = 'The number of Inactive Learners in your account. Inactive Learners will not be included in any part of your account other than anonymously in reporting.';
    $scope.inputPlaceholder = function () {
      return "Search for ".concat($scope.statusFilter.toLowerCase(), " ").concat($scope.selectedType.toLowerCase());
    };
    $scope.shouldHideGroups = function () {
      return $scope.selectedType.toLowerCase() === 'people';
    };
    $scope.shouldHidePeople = function () {
      return $scope.selectedType.toLowerCase() === 'groups';
    };
    $scope.selectType = function (type) {
      if ($scope.selectedType !== type) {
        $scope.searchQuery = '';
      }
      $scope.selectedType = type;
      $scope.setPage(1);
    };
    $scope.applyStatusToSelection = function (selection) {
      var data = $scope.checkedRows.map(function (i) {
        return {
          id: i,
          activeStatus: selection.toUpperCase()
        };
      });
      $http({
        method: 'PUT',
        url: Api.url("/inactive/".concat($scope.selectedType.toLowerCase(), "/multi")),
        data: data
      }).then(function () {
        // Set success msg
        $scope.overhangAlertType = 'success';
        $scope.tableMessage = "Successfully marked ".concat($scope.checkedRows.length, " ").concat($scope.selectedType.toLowerCase(), " as ").concat(selection);

        // Empty the checked results
        $scope.clearToggledRows();

        // Refresh the stats
        getStats();

        // Refresh the current page we're on
        $scope.setPage();

        // Remove the message
        $timeout($scope.clearMessage, 3000);
      }).catch(function (err) {
        $scope.overhangAlertType = "error";
        $scope.tableMessage = err.data.exceptionMessage;
        Logger.error("Error while updating ".concat($scope.selectedType, " in multi-put"), err);
      });
    };
    $scope.applyStatusFilter = function (selection) {
      // Adjust the allowedStatuses array which is just UI logic that determines
      // what options can be selected in the combo box dropdown. This limits users
      // from doing unreasonable things such as settings "Active" users to "Active"
      var capitalizedSelection = selection.charAt(0).toUpperCase() + selection.substr(1).toLowerCase();
      $scope.allowedStatuses = $scope.statuses.filter(function (s) {
        return s !== capitalizedSelection;
      });
      $scope.allowedStatuses = $scope.allowedStatuses.sort();
      if ($scope.statusFilter !== selection.toUpperCase()) {
        $scope.searchQuery = '';
      }
      $scope.statusFilter = selection.toUpperCase();
      $scope.clearToggledRows();
      $scope.setPage(1);
    };

    // -----------------
    // $scoped functions
    // -----------------

    $scope.clearToggledRows = function () {
      return $scope.checkedRows = [];
    };
    $scope.toggleRow = function (index) {
      var id = $scope.rows[index].id;
      var isChecked = $scope.rowIsChecked(id);
      if (isChecked) {
        $scope.checkedRows = $scope.checkedRows.filter(function (i) {
          return i !== id;
        });
      } else {
        $scope.checkedRows.push(id);
      }
    };
    $scope.rowIsChecked = function (id) {
      return $scope.checkedRows.includes(id);
    };
    $scope.wholePageChecked = function () {
      return $scope.rows && $scope.rows.length ? $scope.rows.map(function (r) {
        return r.id;
      }).filter(function (i) {
        return $scope.checkedRows.includes(i);
      }).length === $scope.rows.length : false;
    };
    $scope.toggleRowsInPage = function () {
      if (!$scope.rows || !$scope.rows.length) {
        return;
      }
      var shouldSelect = !$scope.wholePageChecked();
      if (shouldSelect) {
        var _$scope$checkedRows;
        (_$scope$checkedRows = $scope.checkedRows).push.apply(_$scope$checkedRows, _toConsumableArray($scope.rows.map(function (r) {
          return r.id;
        })));
      } else {
        var allIdsInPage = $scope.rows.map(function (r) {
          return r.id;
        });
        $scope.checkedRows = $scope.checkedRows.filter(function (i) {
          return !allIdsInPage.includes(i);
        });
      }
    };
    $scope.search = function () {
      var offset = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      var limit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 10;
      return $http({
        method: 'GET',
        url: Api.url('/inactive/search', false, false),
        params: {
          query: $scope.searchQuery,
          hidePeople: $scope.shouldHidePeople(),
          hideGroups: $scope.shouldHideGroups(),
          hideGroupTypes: $scope.shouldHideGroups(),
          activeStatus: $scope.statusFilter,
          order_by: 'name',
          _limit: limit,
          _offset: offset
        }
      }).then(function (results) {
        return results.data[$scope.selectedType.toLowerCase()];
      }).finally(function () {
        $scope.isLoading.query = false;
        $scope.isLoading.page = false;
      });
    };
    var debouncedSearch = _.debounce(function () {
      $scope.applyStatusFilter($scope.statusFilter);
    }, 1000);
    $scope.onQueryChange = function () {
      $scope.isLoading.query = true;
      debouncedSearch();
    };
    function getStats() {
      delete $scope.licensed;
      delete $scope.active;
      delete $scope.inactive;
      delete $scope.usage;
      $http({
        method: 'GET',
        url: Api.url('/inactive/stats', false, false)
      }).then(function (results) {
        // While slowing the UI to "make things pretty" is generally
        // a bad idea, in this particular case, it makes the stats jump
        // when they are updated really quickly, so a small 200ms delay
        // won't feel slow to the user, but it does give the animations
        // time to run so it looks smooth.
        $timeout(function () {
          $scope.licensed = results.data.activePeopleLicense;
          $scope.active = results.data.activePeople;
          $scope.inactive = results.data.inactivePeople;
          $scope.usage = Utils._try(function () {
            return $scope.active / $scope.licensed * 100;
          }, '--');
          $scope.showOverviewPanel = !_.isUndefined($scope.licensed);
        }, 200);
      }).catch(function (err) {
        Logger.error('Error while getting stats on learners page', err);
      });
    }
    $scope.getOverageClasses = function () {
      var usagePercentage = parseFloat($scope.usage);
      if (isNaN(usagePercentage)) {
        return '';
      }
      if (usagePercentage <= 80) {
        return '';
      } else if (usagePercentage > 100) {
        return 'red';
      } else if (usagePercentage > 90) {
        return 'orange';
      } else {
        return 'yellow';
      }
    };
    $scope.clearMessage = function () {
      $scope.tableMessage = '';
      $scope.overhangAlertType = '';
    };

    // We wait until the pager is loaded so we have access to $scope.setPage
    $scope.onPagerLoad = function () {
      getStats();
      $scope.setPage(1);
    };
  }]);
})();
